// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Il-Xg","row":"styles_row__RzWiE","link":"styles_link__OHIcJ"};